import * as React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import {
  UniversityEntity,
} from 'vse-material-ui';
import {
  UserRegistrationForm,
} from '../../features/account/userRegisterTypes';

export interface RegisterGridProps {
  universityOptions: UniversityEntity[],
  onSubmit: (regForm: UserRegistrationForm) => void,
}

export function RegisterGrid(props: RegisterGridProps) {
  const [userName, setUserName] = React.useState<string>('');
  const [homeUniversityID, setHomeUniversityID] = React.useState<string | number>('');
  const [password, setPassword] = React.useState<string>('');
  const [confirmPassword, setConfirmPassword] = React.useState<string>('');

  return (
    <Grid container>
      <Grid item xs={12} component={Typography} variant='h6'>Create your APRU VSE Application Account</Grid>
      <Grid item xs={12}>
        <TextField
          required
          type='email'
          label='Email'
          value={userName}
          onChange={
            (ev) => setUserName(ev.target.value)
          }
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Home University'
          select
          required
          value={homeUniversityID}
          onChange={
            (ev) => setHomeUniversityID(ev.target.value)
          }
        >
          {props.universityOptions.map((option) => (
            <MenuItem
              key={option.universityID}
              value={option.universityID}>
              {option.universityName}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          required
          type='password'
          label='Password'
          value={password}
          onChange={
            (ev) => setPassword(ev.target.value)
          }
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          required
          type='password'
          label='Confirm Password'
          value={confirmPassword}
          onChange={
            (ev) => setConfirmPassword(ev.target.value)
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="subtitle2">Note</Typography>
        <Typography variant="body2">Your password must be at least 8 characters and contain at least:</Typography>
        <ul>
          <li>one uppercase letter;</li>
          <li>one lowercase letter;</li>
          <li>one numeric; and</li>
          <li>one non-alphanumeric character</li>
        </ul>
      </Grid>
      <Grid item>
        <Button
          variant='contained'
          color='primary'
          onClick={(ev) => {
            ev.preventDefault();
            props.onSubmit({ userName, homeUniversityID, password, confirmPassword });
            setPassword('');
            setConfirmPassword('');
          }}
        >Submit</Button>
      </Grid>
    </Grid>
  );
}
